import {panasonicecmshop } from 'white-labelling/panasonicecmshop';

export default panasonicecmshop;

